// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2PYKY","clinicsSelect":"TableHeading_clinicsSelect__37rCr"};